import { Route } from '@angular/router';

export const PostRoutes: Route[] = [
  {
    path: 'post',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/post/post.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/post/post-detail/post-detail.page'),
      },
    ],
  },
];
